import { useAuth0 } from '@auth0/auth0-react';
import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * IDPHandler handles authentication when ?connection query parameter is present.
 * This component triggers Auth0 login with the specified identity provider connection.
 */
export const IDPHandler = () => {
  const [searchParams] = useSearchParams();
  const { loginWithRedirect } = useAuth0();
  const connection = searchParams.get('connection');
  const companyName = searchParams.get('companyName');

  useEffect(() => {
    if (connection) {
      loginWithRedirect({
        authorizationParams: {
          connection,
        },
        appState: { returnTo: `${window.location.origin}/${companyName}/` },
      }).catch((err) => {
        console.error('IDPHandler: Login failed', err);
      });
    }
  }, [connection, loginWithRedirect]);

  return <div>Redirecting to login...</div>;
};

export default IDPHandler;
